import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import SyncAltIcon from '@material-ui/icons/SyncAlt'
import { makeStyles } from '@material-ui/core/styles'
import { availabilityFill } from './availability-colors'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderTop: '1px solid #E0E0E0',
    backgroundColor: '#FAFBFC',
  },
  bucket: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    [theme.breakpoints.only('xs')]: {
      gap: theme.spacing(1),
    },
  },
  bucketLabel: {
    fontWeight: 600,
    minWidth: 100,
    color: '#172024',
    [theme.breakpoints.only('xs')]: {
      minWidth: 'unset',
      flexBasis: '100%',
    },
  },
  subtype: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  swatch: {
    width: 14,
    height: 14,
    borderRadius: 2,
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  recurring: availabilityFill('recurring'),
  override: availabilityFill('override'),
  blocked: availabilityFill('blocked'),
  synced: availabilityFill('synced'),
  syncedIcon: {
    fontSize: 14,
    color: '#410002',
  },
}))

const Subtype = ({ classes, swatchClass, label, icon }) => (
  <Box className={classes.subtype}>
    <span className={`${classes.swatch} ${swatchClass}`} aria-hidden />
    <Typography variant="body2" color="textSecondary">
      {label}
    </Typography>
    {icon}
  </Box>
)

const Legend = () => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Box className={classes.bucket}>
        <Typography variant="body2" className={classes.bucketLabel}>
          Bookable
        </Typography>
        <Subtype
          classes={classes}
          swatchClass={classes.recurring}
          label="Recurring"
        />
        <Subtype
          classes={classes}
          swatchClass={classes.override}
          label="Open time"
        />
      </Box>
      <Box className={classes.bucket}>
        <Typography variant="body2" className={classes.bucketLabel}>
          Not bookable
        </Typography>
        <Subtype
          classes={classes}
          swatchClass={classes.blocked}
          label="Blocked"
        />
        <Subtype
          classes={classes}
          swatchClass={classes.synced}
          label="Imported · not editable"
          icon={<SyncAltIcon className={classes.syncedIcon} />}
        />
      </Box>
    </Box>
  )
}

export default Legend
